import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import load from '@mailobj-browser/front/js/events/types/load.js'
import meta from '#utilities/js/ea/meta.js'

const counters = new WeakMap()

const onLoad = object(listener, {
  type: load,
  once,
  passive,
  task: iframe => {
    onRedirected.listen(iframe)
  }
})

const onRedirected = object(listener, {
  type: load,
  once,
  passive,
  task: async iframe => {
    const { ownerDocument } = iframe
    const counter = counters.get(iframe) + 1
    const [href] = meta(ownerDocument, 'ads')
    const url = new URL(href)
    const { searchParams } = url
    
    counters.set(iframe, counter)
    searchParams.set('key', counter)
    iframe.src = await (await get(`${url}`)).text()
    onLoad.listen(iframe)
  }
})

export default iframe => {
  counters.set(iframe, 0)
  onLoad.listen(iframe)
}
